const BUFFERED_CONSOLE_LEVELS = [
    'debug',
    'log',
    'warn',
    'error',
    'info'
];
export { BUFFERED_CONSOLE_LEVELS };
